module.exports = __webpack_public_path__ + "img/avatar-6.7f727466.png";